import envCodes from '@/assets/js/envCodes'

const methods = {
  getCategoryCode() {
    return 'C000002'
  },
  getCurveFormItems(allProperties) {
    const allProps = allProperties || []
    const formItemsCodes = ['fluid', 'head']
    const res = []
    formItemsCodes.forEach((item) => {
      const code = envCodes[item]
      const prop = allProps.find((it) => it.code === code) || {}
      item === 'fluid' ? res.push({
        label: prop.name,
        code: prop.code,
        dataType: prop.dataType,
        suffix: prop.unitSymbol,
        suffixes: ['m³/h', 'L/s'],
        required: true,
      }) : res.push({
        label: prop.name,
        code: prop.code,
        dataType: prop.dataType,
        suffix: prop.unitSymbol,
        required: true,
      })
    })
    return res
  },
}
export default {
  namespaced: true,
  ...methods
}
